import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import Alert from "sweetalert-react";
import * as Http from "../../../http";
import Loading from "../../../components/Loading";
import * as Business from "../../../utils/business";

export const REPORT_TYPE = {
  XLSX: "xlsx",
  DOCX: "docx",
  PDF: "pdf",
};

export default class ReportChild extends Component {
  state = {
    items: [],
    loading: true,
    isShow: false,
    showFileDownloadError: false,
    failedDownloadsList: [],
  };

  getReportList = () => {
    Http.getListReport(
      Business.COMPONENT.CAR,
      this.props.report.file_name,
    ).then((data) => {
      const lstReports = [];
      if (data && data.Success && data.Data) {
        data.Data.forEach((item) => {
          if (!Business.isReportFile(item.report_name)) return;
          item.created = Business.convertToFullDate(item.created);
          lstReports.push(item);
        });
      }
      this.setState({ items: lstReports, loading: false });
    });
  };

  onSaveAllFiles = async () => {
    if (this.state.items && this.state.items.length > 0) {
      const fileArr = [];
      for (let i = 0; i < this.state.items.length; i++) {
        const fileInfo = Http.makeDownloadFileInfo(
          this.state.items[i].report_name,
          this.props.report.report_date,
          this.props.report.file_name,
          null,
          Business.COMPONENT.CAR,
        );
        fileArr.push(fileInfo);
      }
      Http.downloadAllFiles(
        fileArr,
        this.props.report.report_date,
        this.props.report.file_name,
      ).then((result) => {
        if (result.is_error) {
          this.setState({
            showFileDownloadError: true,
            failedDownloadsList: result.failed_files,
          });
        }
      });
    }
  };

  show = () => {
    this.setState({
      isShow: true,
      loading: true,
    });
    this.getReportList();
  };

  close = () => {
    this.setState({
      isShow: false,
    });
  };

  renderContent = (items) => {
    const firstItem = items[0];
    const prefix = firstItem ? firstItem.report_name.split("_")[0] || "" : "";
    return (
      <Modal.Body>
        {prefix && <div className="report-prefix-badge">{prefix}</div>}
        <div className="report-detail-list">
          {items.map((item) => {
            const nameWithoutExt = item.report_name.replace(/\.[^.]+$/, "");
            const typePart = prefix
              ? nameWithoutExt.substring(prefix.length + 1)
              : nameWithoutExt;
            return (
              <div className="report-detail-item" key={item.report_name}>
                <span className="report-detail-name">{typePart}</span>
                <div className="report-detail-actions">
                  <button
                    className="report-dl-btn report-dl-xlsx"
                    onClick={() =>
                      Http.downloadFile(
                        item.report_name,
                        this.props.report.report_date,
                        this.props.report.file_name,
                        null,
                        Business.COMPONENT.CAR,
                      )
                    }
                  >
                    <i className="pe-7s-download" /> XLSX
                  </button>
                  <button
                    className="report-dl-btn report-dl-docx"
                    onClick={() =>
                      Http.downloadFile(
                        (item.report_name + "").replace(".xlsx", ".docx"),
                        this.props.report.report_date,
                        this.props.report.file_name,
                        REPORT_TYPE.DOCX,
                        Business.COMPONENT.CAR,
                      )
                    }
                  >
                    <i className="pe-7s-download" /> DOCX
                  </button>
                  <button
                    className="report-dl-btn report-dl-pdf"
                    onClick={() =>
                      Http.downloadFile(
                        (item.report_name + "").replace(".xlsx", ".pdf"),
                        this.props.report.report_date,
                        this.props.report.file_name,
                        REPORT_TYPE.PDF,
                        Business.COMPONENT.CAR,
                      )
                    }
                  >
                    <i className="pe-7s-download" /> PDF
                  </button>
                </div>
              </div>
            );
          })}
        </div>
        <div className="report-detail-footer">
          <button
            type="button"
            className="btn btn-primary report-save-all-btn"
            onClick={this.onSaveAllFiles}
          >
            <i className="pe-7s-download" /> SAVE ALL FILES
          </button>
        </div>
      </Modal.Body>
    );
  };

  renderLoading = () => (
    <div>
      <div style={{ height: 60 }}>
        <Loading size="small" />
      </div>
      <div style={{ height: 30 }} />
    </div>
  );

  render() {
    const { items } = this.state;

    return (
      <div>
        <a
          href="#url"
          style={{ color: "blue" }}
          onClick={(e) => {
            e.preventDefault();
            this.show();
          }}
        >
          {`${this.props.report.file_name}`.substring("CAR_".length)}
        </a>
        <Modal show={this.state.isShow} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>{this.props.report.file_name}</Modal.Title>
          </Modal.Header>
          {this.state.loading
            ? this.renderLoading()
            : this.renderContent(items)}
        </Modal>
        <Alert
          title="Some files failed to download!"
          text={`Please check the following files: ${this.state.failedDownloadsList.join(", ")}`}
          show={this.state.showFileDownloadError}
          onConfirm={() => {
            this.setState({ showFileDownloadError: false });
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/CAR/Reports/ReportChild.js